"use client";

import React from "react";

import { AccessibilityLabels } from "~/constants/accessibility";
export type AccessibilityLabelsContextValue = AccessibilityLabels | null;

export const AccessibilityLabelsContext =
  React.createContext<AccessibilityLabelsContextValue>(null);
